/**
 * Sampling / prélèvement FeatureModule — the waiting-room queue, the draw lifecycle, discipline
 * routing / bench boards, and matricule/vignette print.
 *
 * Registration is 3 steps (no router/shell edit): this default export + one line in src/app/registry.ts.
 * The module gates on `sampling.file.read` (the read any screen needs); the print nav item gates
 * tighter on `sampling.matricule.print`. Every mutating action is gated in-screen via useCan — the
 * server re-checks every request.
 */
import type { FeatureModule } from "@/app";
import { CAP } from "./capabilities";
import { registerSamplingMessages } from "./i18n";
import { QueueBoardScreen } from "./screens/QueueBoardScreen";
import { BenchBoardsScreen } from "./screens/BenchBoardsScreen";
import { MatriculePrintScreen } from "./screens/MatriculePrintScreen";

const SECTION = "nav.section.sampling";

const samplingModule: FeatureModule = {
  id: "sampling",
  title: "Prélèvement",
  requiredCapabilities: [CAP.fileRead],
  routes: [
    { path: "/sampling", element: <QueueBoardScreen /> },
    { path: "/sampling/paillasses", element: <BenchBoardsScreen /> },
    { path: "/sampling/matricule", element: <MatriculePrintScreen /> },
  ],
  nav: [
    {
      id: "sampling-queue",
      path: "/sampling",
      label: "nav.sampling.queue",
      icon: "⧖",
      order: 30,
      section: SECTION,
    },
    {
      id: "sampling-benches",
      path: "/sampling/paillasses",
      label: "nav.sampling.benches",
      icon: "▦",
      order: 31,
      section: SECTION,
    },
    {
      id: "sampling-print",
      path: "/sampling/matricule",
      label: "nav.sampling.print",
      icon: "⎙",
      order: 32,
      section: SECTION,
      requiredCapabilities: [CAP.matriculePrint],
    },
  ],
  onRegister() {
    registerSamplingMessages();
  },
};

export default samplingModule;
